<template>
    <!-- «Стоп-піца»: піца бігає доріжкою туди-сюди, треба зупинити її на червоній позначці.
         Кожен по одній спробі; найдалі від центру — платить. Позиція рахується на момент дотику, не кадру -->
    <div class="bp-wp-game">
        <p class="bp-wp-turn" aria-live="polite">
            <template v-if="state == 'done'">Найдалі від позначки: <b>{{ players[loser] }}</b>!</template>
            <template v-else>Черга: <b>{{ players[current] }}</b></template>
        </p>
        <div class="bp-wp-track" @pointerdown.prevent="state == 'move' && stop()">
            <span class="bp-wp-track__zone" aria-hidden="true"></span>
            <span v-for="m in marks" :key="m.i" class="bp-wp-track__mark" :style="{ left: 'calc(44px + ' + m.x + ' * (100% - 88px))' }" :title="players[m.i]">{{ initial(m.i) }}</span>
            <span class="bp-wp-track__pizza" :style="{ left: 'calc(44px + ' + x + ' * (100% - 88px))' }">
                <img v-if="photo" :src="photo" alt="">
                <span v-else class="bp-wp-track__dot"></span>
            </span>
        </div>
        <p class="bp-wp-hint">{{ hint }}</p>
        <button type="button" class="bp-wp-btn bp-wp-btn--main" :disabled="state == 'done' || state == 'wait'" @click="state == 'move' ? stop() : go()">
            {{ state == 'move' ? 'Стоп!' : 'Старт' }}
        </button>
        <ol class="bp-wp-board">
            <li v-for="(name, i) in players" :key="i" :class="{ 'is-now': state != 'done' && i == current, 'is-lose': state == 'done' && i == loser }">
                <span class="bp-wp-board__name">{{ name }}</span>
                <span class="bp-wp-board__val">{{ dev[i] != null ? dev[i] + ' %' : '—' }}</span>
            </li>
        </ol>
    </div>
</template>

<script>
// Повний прохід доріжки туди й назад — 1,2 с; позиція — «пила-трикутник» від часу з випадковим зсувом
const PERIOD = 1200;

export default {
    name: 'GameStop',
    props: {
        players: { type: Array, required: true },
        photo: { type: String, default: '' }
    },
    data() {
        return {
            current: 0,
            x: .5,
            state: 'ready',
            dev: this.players.map(() => null),
            marks: [],
            loser: null,
            t0: 0,
            raf: null,
            hint: 'Натисніть «Старт», а тоді «Стоп!», коли піца на червоній позначці'
        }
    },
    beforeDestroy() {
        cancelAnimationFrame(this.raf);
    },
    methods: {
        initial(i) {
            return String(this.players[i]).trim().charAt(0).toUpperCase();
        },
        pos(now) {
            const t = ((now - this.t0) % PERIOD) / PERIOD;
            return t < .5 ? t * 2 : 2 - t * 2;
        },
        go() {
            if (this.state != 'ready') return;
            this.t0 = performance.now() - Math.random() * PERIOD;
            this.state = 'move';
            this.hint = 'Тисніть «Стоп!» або на доріжку';
            const loop = () => { this.x = this.pos(performance.now()); this.raf = requestAnimationFrame(loop); };
            loop();
        },
        stop() {
            if (this.state != 'move') return;
            cancelAnimationFrame(this.raf);
            const x = this.pos(performance.now());
            this.x = x;
            const who = this.current;
            const d = Math.round(Math.abs(x - .5) * 200);
            this.$set(this.dev, who, d);
            this.marks.push({ i: who, x });
            this.hint = d <= 3 ? 'Майже в яблучко!' : 'Відхилення ' + d + ' %';
            if (who < this.players.length - 1) {
                this.state = 'wait';
                setTimeout(() => { this.current++; this.state = 'ready'; this.x = .5; this.hint = 'Передайте телефон: ' + this.players[this.current]; }, 1000);
                return;
            }
            const max = Math.max(...this.dev);
            const tied = this.players.map((_, i) => i).filter(i => this.dev[i] === max);
            this.loser = tied[Math.floor(Math.random() * tied.length)];
            this.state = 'done';
            setTimeout(() => this.$emit('done', { loser: this.loser, note: 'Відхилення ' + max + ' % від позначки' }), 1300);
        }
    }
}
</script>
